import { render, staticRenderFns } from "./product-env-impact-score.vue?vue&type=template&id=272db056"
import script from "./product-env-impact-score.vue?vue&type=script&lang=js"
export * from "./product-env-impact-score.vue?vue&type=script&lang=js"
import style0 from "./product-env-impact-score.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports